<!--
  Copyright by:
  by ESS-Ehrhardt Software Solutions & Service GmbH
  Basselscheider Str. 55
  D-56281 Emmelshausen
  +49 (0) 67 42 / 87 27 0
  info@epg.com
-->

<div class="gantt-chart-container" [style.height]="height">
  <div 
    class="gantt-chart"
    [class]="'gantt-chart ' + animationClass"
    [style.border-radius]="borderRadius"
    *ngIf="segments.length > 0; else emptyState">
    <div 
      *ngFor="let segment of segments; trackBy: trackBySegment" 
      class="gantt-segment"
      [class.gantt-segment-scheduled]="segment.type === 'scheduled'"
      [class.gantt-segment-split]="segment.isSplit"
      [class.gantt-segment-zero]="segment.percentage === 0"
      [style.width.%]="animationClass === 'gantt-chart-loading' ? 0 : segment.percentage"
      [style.background-color]="segment.type === 'scheduled' ? 'transparent' : (segment.isSplit ? 'transparent' : segment.color)"
      [title]="getTooltipText(segment)"
      [attr.aria-label]="getAriaLabel(segment)"
      [attr.tabindex]="0"
      [attr.role]="'button'"
      (click)="!segment.isSplit && onSegmentClick(segment)"
      (keydown)="onKeyDown($event)">
      
      <div *ngIf="segment.isSplit && segment.splitData" class="gantt-split-container">
        <div 
          class="gantt-split-left"
          [style.width.%]="animationClass === 'gantt-chart-loading' ? 0 : segment.splitData.left.percentage"
          [style.background-color]="segment.splitData.left.color"
          [title]="segment.splitData.left.label + ': ' + segment.splitData.left.value + ' ' + tasksText"
          (click)="onSplitSegmentClick(segment, 'left')">
        </div>
        <div 
          class="gantt-split-right"
          [style.width.%]="animationClass === 'gantt-chart-loading' ? 0 : segment.splitData.right.percentage"
          [style.background-color]="segment.splitData.right.color"
          [title]="segment.splitData.right.label + ': ' + segment.splitData.right.value + ' ' + tasksText"
          (click)="onSplitSegmentClick(segment, 'right')">
        </div>
      </div>
    </div>
  </div>
  
  <ng-template #emptyState>
    <div class="gantt-chart gantt-chart-empty" [style.border-radius]="borderRadius">
      <div class="gantt-segment gantt-segment-empty"></div>
    </div>
  </ng-template>
  
  <div *ngIf="showLabels && segments.length > 0" class="gantt-labels">
    <span 
      *ngFor="let segment of segments; trackBy: trackBySegment" 
      class="gantt-label"
      [style.width.%]="segment.percentage">
      {{segment.value}}
    </span>
  </div>
</div>
